module.exports = "<header>\r\n  <app-top-navigation></app-top-navigation>\r\n</header>\r\n\r\n\r\n<main>\r\n  <router-outlet></router-outlet>\r\n</main>\r\n\r\n<footer>\r\n  <app-footer></app-footer>\r\n</footer>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/projektyWeb/McComp_Flota/Front/src/app/pages/dashboard/dashboard.component.html
// module id = ../../../../../src/app/pages/dashboard/dashboard.component.html
// module chunks = main